import { z } from "zod";
import { isoDay, optionalText, uuid } from "./common.js";

export const financeAccountSchema = z.object({
  name: z.string().trim().min(1).max(120),
  kind: z.enum(["cash", "bank", "card"]).default("bank"),
  iban: optionalText(34),
  openingCents: z.number().int().default(0),
  isDefault: z.boolean().default(false),
});

export const supplierInvoiceSchema = z.object({
  companyId: uuid.nullable().optional(),
  supplierName: z.string().trim().min(1).max(200),
  supplierVat: optionalText(30),
  number: z.string().trim().min(1).max(60),
  issueDate: isoDay,
  dueDate: isoDay.nullable().optional(),
  category: optionalText(80),
  description: optionalText(2000),
  netCents: z.number().int().min(0),
  vatCents: z.number().int().min(0).default(0),
  projectId: uuid.nullable().optional(),
});
export type SupplierInvoiceInput = z.infer<typeof supplierInvoiceSchema>;

export const ledgerEntrySchema = z.object({
  accountId: uuid,
  date: isoDay,
  description: z.string().trim().min(1).max(300),
  amountCents: z.number().int().refine((v) => v !== 0, "Importo diverso da zero"),
  category: optionalText(80),
  invoiceId: uuid.nullable().optional(),
  supplierInvoiceId: uuid.nullable().optional(),
});

export const LEDGER_CATEGORIES = [
  "Vendite",
  "Consulenze",
  "Software e abbonamenti",
  "Collaboratori",
  "Affitto e utenze",
  "Tasse e contributi",
  "Banca e commissioni",
  "Marketing",
  "Altro",
] as const;

export const scheduleQuerySchema = z.object({ from: isoDay.optional(), to: isoDay.optional(), direction: z.enum(["in", "out", "all"]).default("all") });

export const accountantExportSchema = z.object({ from: isoDay, to: isoDay, format: z.enum(["csv", "xlsx"]).default("csv") });

export const invoiceBillableSchema = z.object({
  projectId: uuid,
  taskIds: z.array(uuid).min(1).max(500),
  vatRate: z.number().min(0).max(100).default(22),
});
